import dynamic from 'next/dynamic';
import { useState } from 'react';
import { toast } from 'react-toastify';

import AvatarPlaceholder from '@/components/avatar-default';
import { useAuth } from '@/provider/UserProvider';

const DynamicCreatePostModal = dynamic(() => import('./CreatePostModal'));

const CreatePost: React.FC<any> = ({}) => {
  const [toggleModalShare, setToggleModalShare] = useState(false);
  const { auth, isLogin } = useAuth();

  const handleToggleModal = () => {
    if (!isLogin) {
      return toast.error('You must login to continue');
    }
    setToggleModalShare(true);
  };
  return (
    <div className="flex w-full items-center gap-4">
      <AvatarPlaceholder
        src={auth?.user?.picture}
        alt="avatar"
        address={auth?.user?.publicAddress}
        className="h-12 w-12 rounded-full"
      />
      <div className="flex w-full flex-col items-start gap-[10px] rounded-[100px] bg-gray-50 px-4 py-3">
        <input
          className="w-full border-none bg-gray-50 outline-none"
          placeholder="Which artwork do you want to share?"
          onClick={() => handleToggleModal()}
        />
      </div>
      {toggleModalShare && (
        <DynamicCreatePostModal
          toggleModalShare={toggleModalShare}
          setToggleModalShare={setToggleModalShare}
        />
      )}
    </div>
  );
};

export default CreatePost;
